import { styled } from '@atom-web/core'
import { Accordion } from '@atom-web/macros'
import { Column, Divider, Flex, Row, Stack, Text } from '@atom-web/micros'

import { brandContent, pytSection, socialContent } from '../../../data/footer'
import ContentWrapper from '../../ContentWrapper'
const Wrapper = styled(Stack, {
	paddingBottom: 12,
	'@lg': {
		flexDirection: 'column',
	},
})

const Section = styled(Column, {
	justifyContent: 'center',
	alignItems: 'center',
	paddingTop: 40,
	'@lg': {
		paddingTop: 64,
	},
	'@xl': {
		width: 992,
	},
	'@xxl': {
		width: '100%',
	},
})

const SectionHeader = styled(Text, {
	display: 'flex',
	justifyContent: 'center',
	margin: 0,
	marginBottom: '$8',
	'@lg': {
		marginBottom: '40px',
	},
	'@smMax': {
		textAlign: 'center',
	},
})

const PartnersDesktopImage = styled('img', {
	display: 'none',
	maxWidth: '95%',
	paddingBottom: '40px',
	height: 'auto',
	'@lg': {
		display: 'unset',
	},
})

const PartnersMobileImage = styled('img', {
	maxWidth: '95%',
	paddingBottom: '40px',
	height: 'auto',
	'@lg': {
		display: 'none',
	},
})

const BrandImage = styled('img', {
	width: '80%',
	height: '260px',
	display: 'none',

	'@lg': {
		width: '381px',
		height: '260px',
		display: 'unset',
	},
})

const BrandTextWrapper = styled(Column, {
	width: '100%',
	gap: '$3',
	padding: '$3',
	'@lg': {
		width: '40%',
		paddingLeft: '$3',
		paddingRight: '$3',
	},
})

const BrandText = styled(Text, {
	margin: 0,
	fontSize: 13,
	lineHeight: '$3',
})

const PackagesWrapper = styled(Stack, {
	'@lg': {
		flexDirection: 'column',
		padding: 'unset',
		justifyContent: 'flex-start',
	},
})

const PackagesHeader = styled(Text, {
	marginTop: '$5',
	marginBottom: '$2',
	fontSize: '$4',
	fontWeight: '$bold',
	lineHeight: '$3',
	color: '$grey07',
})

const PackagesLink = styled('a', {
	display: 'flex',
	gap: '$2',
	fontSize: '$2',
	alignItems: 'center',
	textDecoration: 'none',
	outline: '0 none',
	color: '$white',
	fill: '$white',
	marginRight: '$2',
	lineHeight: '$3',
	'&:hover': {
		color: '$custom03',
		fill: '$custom03',
	},
	'@lg': {
		fontSize: '$3',
	},
})

const IconLink = styled('a', {
	textDecoration: 'none',
	marginRight: '$1',
})

export default ({
	footerData,
	css,
	hideTrustSection = false,
	hideBrandSection = false,
}) => {
	return (
		<Flex
			id="footer-wrapper"
			css={{
				width: '100%',
				background: '$black',
				color: '$white',
				...css,
			}}
		>
			<ContentWrapper>
				<Wrapper>
					{/* trusted partners section */}
					{!hideTrustSection && (
						<Section>
							<SectionHeader size="5">
								Our trusted travel partners around the world
							</SectionHeader>
							<PartnersDesktopImage
								src="https://pyt-images.imgix.net/images/web_app/homepage/web-min.png?dpr=2&auto=format,compress,enhance&q=20"
								alt="partners-image"
							/>
							<PartnersMobileImage
								src="https://pyt-images.imgix.net/images/web_app/homepage/mobile-min.png?dpr=2&auto=format,compress,enhance&q=20"
								alt="partners-image"
							/>
							<Divider
								decorative
								css={{
									backgroundColor: '$custom02',
								}}
							/>
						</Section>
					)}

					{/* brand section */}
					{!hideBrandSection && (
						<Section>
							<Row
								css={{
									justifyContent: 'space-between',
									marginBottom: '$8',
								}}
							>
								<BrandTextWrapper>
									{brandContent.map((value, index) => (
										<BrandText key={'brand-text' + index}>{value}</BrandText>
									))}
								</BrandTextWrapper>
								<BrandImage
									src="http://pyt-images.imgix.net/images/web_app/homepage/footer_logo.gif"
									alt="PickYourTrail.com - Build, Customize and Book personalized vacations!"
								/>
							</Row>
							<Divider
								decorative
								css={{
									backgroundColor: '$custom02',
								}}
							/>
						</Section>
					)}
					{/* packages section */}
					<PackagesWrapper>
						{/* desktop */}
						<Stack
							css={{
								display: 'none',
								'@xl': {
									display: 'unset',
									flexDirection: 'column',
									paddingTop: '$6',
								},
							}}
						>
							{footerData &&
								(footerData || [])?.map(({ category, destinations }, index) => (
									<Column
										key={'packages' + index}
										css={{
											gap: '$5',
										}}
									>
										<Column
											css={{
												paddingLeft: '$3',
												paddingRight: '$3',
											}}
										>
											<PackagesHeader size="3">{category}</PackagesHeader>
											<Stack
												css={{
													width: '100%',
													flexWrap: 'wrap',
												}}
												gap={1}
												seperator={
													<Text
														css={{
															// transform: 'translateY(-10%)',
															marginRight: '$2',
														}}
													>
														.
													</Text>
												}
											>
												{destinations?.map(({ name, url }, index) => (
													<PackagesLink
														href={url}
														key={`${category}-${destinations}` + index}
													>
														{name}
													</PackagesLink>
												))}
											</Stack>
										</Column>
										<Divider
											decorative
											css={{
												backgroundColor: '$custom02',
											}}
										/>
									</Column>
								))}

							{/* brand section */}
							<Section
								css={{
									paddingTop: '$8',
									alignItems: 'flex-start',
								}}
							>
								<Row
									css={{
										marginBottom: '$8',
										width: '100%',
									}}
								>
									{pytSection.map(({ category, contents, extras }, index) => (
										<Column
											key={'item' + index}
											css={{
												width: '25%',
												rowGap: 6,
												paddingLeft: '$3',
												paddingRight: '$3',
											}}
										>
											<PackagesHeader
												size={3}
												css={{
													margin: 0,
												}}
											>
												{category}
											</PackagesHeader>
											{contents.map(({ name, url, icon }) => (
												<Column
													key={'desktop' + (name || (icon && icon)) + index}
													css={{
														gap: 6,
													}}
												>
													<PackagesLink href={url}>
														{icon}
														{name}
													</PackagesLink>
												</Column>
											))}
											<Row
												css={{
													marginTop: '$6',
												}}
											>
												{extras && extras}
											</Row>
										</Column>
									))}
								</Row>
							</Section>
						</Stack>

						{/* mobile */}
						<Stack
							css={{
								marginTop: !hideBrandSection ? '-$2' : 0,
								paddingTop: hideBrandSection ? '$9' : 0,
								display: 'unset',
								'@xl': {
									display: 'none',
								},
							}}
						>
							<Accordion.Root type="single">
								{footerData &&
									(footerData || [])?.map(({ category, destinations }, inx) => (
										<Accordion.Item
											value={'accordion' + inx}
											key={'accordion' + inx}
										>
											<Accordion.Trigger>
												<Text size="3" css={{ fontWeight: 500 }}>
													{category}
												</Text>
											</Accordion.Trigger>
											<Accordion.Content>
												<Stack
													gap={'0'}
													css={{
														flexDirection: 'row',
														flexWrap: 'wrap',
													}}
													seperator={<PackagesLink>.</PackagesLink>}
												>
													{destinations.map(({ name, url }, index) => (
														<PackagesLink
															href={url}
															key={'mobile' + name + index}
														>
															{name}
														</PackagesLink>
													))}
												</Stack>
											</Accordion.Content>
										</Accordion.Item>
									))}
							</Accordion.Root>
							<Stack
								css={{
									marginTop: '$6',
									marginBottom: '$4',
									flexDirection: 'row',
									width: '100%',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								gap={2}
								seperator={<PackagesLink>.</PackagesLink>}
							>
								{socialContent.map(({ icon, url }, index) => (
									<IconLink
										href={url}
										target="_blank"
										key={'social-link' + index}
									>
										{icon}
									</IconLink>
								))}
								<Text
									size="3"
									css={{
										lineHeight: '$3',
										marginTop: '$3',
										textAlign: 'center',
									}}
								>
									Travel Troops Global Private Ltd. ©{' '}
									{new Date().getUTCFullYear()} all rights reserved.
								</Text>
							</Stack>
						</Stack>
					</PackagesWrapper>
				</Wrapper>
			</ContentWrapper>
		</Flex>
	)
}
